import React from 'react';
import { Routines } from '../components';
import { withRouter } from 'us.common/wIthRouter';
import { useNavigate } from 'react-router-dom';
// import { withRouter, RouteComponentProps } from 'react-router-dom';

// interface ICnt_Routines extends RouteComponentProps {

// }

interface ICnt_Routines {

}


const Cnt_Routines = (props: ICnt_Routines) => {
    const navigate = useNavigate();
    
    const onMinimize = () => {
        // props.history.push('')
        navigate('')
    }

    return (
        <Routines.Home onMinimize={onMinimize} />
    )
}

export default withRouter(Cnt_Routines);